import { Box, Divider, Flex } from 'juhuui';
import React from 'react';
import { config, useSpring } from 'react-spring';

import { Animated, AnimatedLine, Link, TextSm } from '../styles';

function LinkBarItem({
  active = false,
  after = false,
  item,
  last,
  first,
  firstActive,
  index,
  setActive,
}) {
  const borderStyles = useSpring({
    width: active ? '101%' : '0%',
    config: config.molasses,
  });
  const boxStyles = useSpring({
    x: !first && !firstActive && (active || after) ? '0.5rem' : '0rem',
    config: config.molasses,
  });

  return (
    <Animated
      css={{
        pr: !last && ['4', undefined, '6'],
      }}
      style={boxStyles}
      // _hover={{ color: 'tom.textHighlight' }}
      onClick={() => setActive && setActive(index)}
    >
      <Link css={{ cursor: 'pointer' }} to={item.to}>
        {item.title}
      </Link>
      {active && (
        <Flex
          css={{
            justify: 'space-between',
          }}
        >
          <AnimatedLine
            css={{
              w: 'half',
            }}
            style={borderStyles}
          />
          <AnimatedLine
            css={{
              w: 'half',
            }}
            style={borderStyles}
          />
        </Flex>
      )}
    </Animated>
  );
}

export default LinkBarItem;
